import { Clipboard } from '@angular/cdk/clipboard';
import { Component, OnInit, Inject, Input          } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA      } from '@angular/material/dialog';
import { DialogsReturnCode                  } from 'src/app/enums/dialogs/returnCode.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { HandlerManager                     } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                     } from 'src/app/managers/loading/loading.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { SessionManager                     } from 'src/app/managers/session/session.manager';

@Component
({
  selector: 'clipboard-dialog',
  templateUrl: './clipboard.dialog.html',
  styleUrls: ['./clipboard.dialog.scss'],
})

export class ClipboardDialog implements OnInit 
{
  title             : string = "dialog.clipboard.title"
  clipboard_text    : string 
  clipboard_label   : string = "dialog.clipboard.label"
  confirm_text      : string = "dialog.clipboard.ok"

  values            : any    = []

  constructor
  (
    private dialogRef : MatDialogRef<ClipboardDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any      ,
    
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private clipboard: Clipboard,
    private _notifier: NotifierManager
  ) {}

  ngOnInit(): void
  {
    if(this.data)
    {
      if(this.data.title            ) this.title              = this.data.title 
      if(this.data.clipboard_text   ) this.clipboard_text     = this.data.clipboard_text 
      if(this.data.clipboard_label  ) this.clipboard_label    = this.data.clipboard_label 
      if(this.data.confirm_text     ) this.confirm_text       = this.data.confirm_text


      if(this.data.values           ) this.values             = this.data.values
    }
  }

  copyToClipboard( text: string ) {
    const done = this.clipboard.copy(text);
    if( done ){
      this._notifier.show(
        Notifier.INFO,
        NotifierMessage.COPIED_TO_CLIPBOARD
      )
    }else{
      this._notifier.show(
        Notifier.ERROR,
        NotifierMessage.NOT_COPIED_TO_CLIPBOARD
      )
    }
  }

  //---------------------------------------------------------------------------------------------------
  
  close()
  {
    this.dialogRef.close()
  }
}
